import { useEffect, useState } from 'react'
import { getPlayerCoinHistoryBlueday } from '../../Api/UserPanel/UserPanel'


export const useGetPlayerCoinHistoryBlueday = ({ form }: { form: { name: string } }) => {

    const [playerCoinHistory, setPlayerCoinHistory] = useState< any | null>(null)
    const [loading, setLoading] = useState(false)

    const getCoinHistory = async () => {
        setLoading(true)
        const response = await getPlayerCoinHistoryBlueday({ name: form?.name?.trim() })
        setPlayerCoinHistory(response)
        setLoading(false)
    }

    useEffect(() => {
        getCoinHistory()
    }, [form?.name])

    return {
        playerCoinHistory,
        loading,
        getCoinHistory
    }



}
